import { render, staticRenderFns } from "./PrimeQuizz.vue?vue&type=template&id=0ef72528&"
import script from "./PrimeQuizz.vue?vue&type=script&lang=js&"
export * from "./PrimeQuizz.vue?vue&type=script&lang=js&"
import style0 from "./PrimeQuizz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports